<template>
  <div>
    <div class="list-group-item user-account-title p-l-30" @click="toggleAccountsView">
      <div v-if="last_nm">
        <h4>
          {{ last_nm }}, {{ first_nm }}
          <span v-if="is_sys_admin == 1" class="label label-outline m-l-5">System Admin</span>
          <span v-else class="label label-outline m-l-5">{{ accountCountDisplay }}</span>
          <span v-show=hasPendingApproval class="label label-warning m-l-5 text-uppercase">Waiting Approval</span>
          <a @click.stop="accountProfile">
            <span class="label label-profile m-l-5  ">View Profile</span>
          </a>

          <a @click.stop="accountProfile" v-show="is_locked == 1" class="label label-locked m-l-5">
            <span class="fa fa-lock m-r-5"></span> Locked</a>
          <span v-show="status_cd == 'IN'" class="label label-inactive m-l-5">
            <span class="fa fa-user m-r-5"></span> Inactive</span>

          <span v-if="is_sys_admin == 0">
            <button type="button" class="btn text m-l-10" @click="switchUser" @click.stop="">
              <span class="fa fa-magic"></span>Change User
            </button>
          </span>

        </h4>
      </div>
      <div v-else>
        <h4>
          No User Details
          <span v-if="is_sys_admin == 1" class="label label-outline m-l-5">System Admin</span>
          <span v-else class="label label-outline m-l-5 text-uppercase">
            {{ user_accounts ? user_accounts.length + ' Accounts' : '0 Account' }}
          </span>

          <span v-show=hasPendingApproval class="label label-warning m-l-5 text-uppercase">Waiting Approval</span>
          <a @click.stop="accountProfile">
            <span class="label label-profile m-l-5">View Profile</span>
          </a>
          <a @click.stop="accountProfile" v-show="is_locked == 1" class="label label-locked m-l-5">
            <span class="fa fa-lock m-r-5"></span> Locked</a>
          <span v-show="status_cd == 'IN'" class="label label-inactive m-l-5">
            <span class="fa fa-user m-r-5"></span> Inactive</span>

          <span v-if="is_sys_admin == 0">
            <button type="button" class="btn text m-l-10" @click="switchUser" @click.stop="">
              <span class="fa fa-magic"></span>Change User
            </button>
          </span>
        </h4>
      </div>
      <span v-show="status_cd == 'PEND'">
        <span class="label label-warning m-l-5 pull-right">Pending Registration</span>
      </span>
      <a @click.stop="" :href="'mailto:' + email">{{ email }}</a> {{ user_details }}
      <div v-show="last_nm">Last Login: {{ (current_login_ts ? current_login_ts : 'Never') }}</div>
    </div>
    <div>
      <div class="list-group-item" v-show=showAccounts>
        <sys-admin-account-role-list v-for="(user_account, index) in user_accounts" :key="user_account.account_nbr"
          :index="index" :user_id="user_id" :first_nm="first_nm" :last_nm="last_nm"
          :account_nbr="user_account.account_nbr" :account_nm="user_account.account.account_nm"
          :account_city="user_account.account.city" :account_state="user_account.account.state_cd"
          :account_industry_id="user_account.account.default_industry_id"
          :has_pending_approval="user_account.has_pending_approval" :industry_list="industry_list"
          :all_roles="all_roles" :user_account_roles="user_account.rolesArray"
          :is_credit_and_collection="user_account.account.is_credit_and_collection"></sys-admin-account-role-list>

        <!-- row add account-->
        <div class="row m-l-0">

          <div class="col-lg-3">
            <div class="form-group fg-line">
              <label for="addAccountNbr">Account Number</label>
              <span class="fg-line">
                <input id="addAccountNbr" class="form-control" name="addAccountNbr" v-model="add_account_nbr"
                  type="text" v-on:keyup.enter="addAccount">
              </span>
              <span v-if="form_errors['add_account_nbr']" class="simple-error">{{ form_errors['add_account_nbr']
              }} </span>
              <span v-else class="help-block">Add an account to this user</span>
            </div>
          </div>

          <div class="col-lg-6">
            <button class="btn add-btn" type="button" @click="addAccount"><span class="fa fa-plus"></span>
              &nbsp;Add
              Account
            </button>
          </div>

        </div><!-- /row add account -->


      </div>
    </div>
  </div>
</template>

<script>
module.exports = {
  props: [
    'user_id',
    'last_nm',
    'first_nm',
    'is_sys_admin',
    'status_cd',
    'is_locked',
    'user_accounts',
    'email',
    'phone1',
    'city',
    'state_cd',
    'current_login_ts',
    'profile_link',
    'industry_list',
    'all_roles',
    'total_users',

  ],
  data: function () {
    return {
      showAccounts: false,
      add_account_nbr: '',
      form_errors: {},
    }
  },
  computed: {
    accountCountDisplay: function () {
      if (!this.user_accounts) {
        return '0 Accounts';
      } else if (this.user_accounts.length == 1) {
        return '1 Account'
      } else {
        return this.user_accounts.length + ' Accounts'
      }
    },
    user_details: function () {
      if (this.last_nm) {
        return '- ' + this.phone1 + ' - ' + this.city + ', ' + this.state_cd;
      } else {
        return '';
      }
    },
    hasPendingApproval: function () {
      if (!this.user_accounts || !this.user_accounts.length) {
        return false;
      }

      for (var i = 0; i < this.user_accounts.length; i++) {
        if (this.user_accounts[i].has_pending_approval) {
          return true;
        }
      }
      return false;
    },


  },
  methods: {
    toggleAccountsView: function () {
      if (this.total_users > 1) {
        this.showAccounts = !this.showAccounts;
      }
    },

    addAccount: function () {
      this.form_errors = {};
      if (this.add_account_nbr.trim().length == 0) {
        this.form_errors['add_account_nbr'] = 'The account number must be entered';
      } else if (isNaN(this.add_account_nbr)) {
        this.form_errors['add_account_nbr'] = 'The account number must be numeric';
      } else {
        this.$http.get('/admin/users/verify/account',
          {
            params: {
              'account_nbr': this.add_account_nbr,
              'user_id': this.user_id
            }
          })

          .then(function (response) {
            this.user_accounts.push(response.data.user_account);
            this.add_account_nbr = "";
          })
          .catch(function (data, status, request) {
            this.form_errors = Object.assign({}, { 'add_account_nbr': 'Unable to get Details for Account' });
          });
      }
    },

    switchUser: function () {
      this.$http.post('/admin/change-visible-user', { user_id: this.user_id })
        .then(function (response) {
          window.location.href = '/';
        });
    },
    resetPending: function (index) {
      this.user_accounts[index].has_pending_approval = false;
    },

    accountProfile: function () {
      window.location.href = this.profile_link;
    }
  },

  mounted: function () {
    if (this.total_users == 1) {
      this.showAccounts = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// sys-admin-user-list-item.vue?780bd274